import {DATALIST} from './dataListTypes'

export const changeDataList = dataList => {
    return {
        type: DATALIST,
        load: dataList
    }
}

export const selectDataList = (dataList) => {

    return (dispatch) => {
        dispatch(changeDataList(dataList))
    }

}